import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import SliderNew from 'components/slider-new'
import { JRL_MERCH_CATALOG } from 'lib/jrl-merch/catalog.generated'
import JrlMerchProductCard from './JrlMerchProductCard'
import { baseConfig } from 'components/slider-new/utils'

const SHOP_URL =
  'https://clubshop.macron.com/macron_sportswear_us/pga-jr-league-merchandise-shop/kit-top-up'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  heading: {
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  helper: {
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
  },
}))

export default function JrlMerchCarousel({
  catalog = JRL_MERCH_CATALOG,
  heading = 'Shop PGA Jr. League gear',
  helperText = 'Provided by our partners at Macron',
}) {
  const classes = useStyles()

  const legacyShop = (
    <Box>
      <Typography align="center">
        <a href={SHOP_URL} target="_blank" rel="noreferrer">
          Shop PGA Jr. League clothing and apparel.
        </a>
      </Typography>
    </Box>
  )

  const sliderConfig = {
    ...baseConfig,
    slides: {
      ...baseConfig.slides,
      perView: 1,
      spacing: 0,
    },
    breakpoints: {
      ...baseConfig.breakpoints,
      '(min-width: 600px)': {
        loop: false,
        slides: { perView: 1, spacing: 0 },
      },
    },
  }

  if (!catalog || catalog.length === 0) {
    return legacyShop
  }

  return (
    <Box className={classes.root} data-testid="jrl-merch-carousel">
      <Typography variant="h6" className={classes.heading}>
        {heading}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        className={classes.helper}
      >
        {helperText}
      </Typography>

      <Box mt={2}>
        <SliderNew config={sliderConfig}>
          {catalog.map(product => (
            <JrlMerchProductCard key={product.id} product={product} />
          ))}
        </SliderNew>
      </Box>
    </Box>
  )
}
